import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [showCookieCare, setShowCookieCare] = useState(false);
  const [showShippingPolicy, setShowShippingPolicy] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  function handleFormSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    fetch('https://formsubmit.co/ajax/crumbssicookies@gmail.com', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    }).then(() => {
      setFormSubmitted(true);
      form.reset();
      setTimeout(() => setFormSubmitted(false), 4000);
    }).catch(() => {
      // Fallback: open mailto
      const name = formData.get('name') || '';
      const email = formData.get('email') || '';
      const phone = formData.get('phone') || '';
      const message = formData.get('message') || '';
      window.location.href = `mailto:crumbssicookies@gmail.com?subject=Contact from ${name}&body=Name: ${name}%0AEmail: ${email}%0APhone: ${phone}%0A%0A${message}`;
    });
  }
  return <>
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/20 border-b border-white/30 shadow-sm" data-id="element-139">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
          <div className="flex justify-between items-center h-20" data-id="element-141">
            <div className="hidden md:flex flex-1 justify-end pr-8 space-x-8" data-id="element-142">
              <a href="#menu" className="text-brand-purple font-semibold hover:opacity-70 transition-opacity" data-id="element-143">
                Build My Box
              </a>
              <button onClick={() => setShowCookieCare(true)} className="text-brand-purple font-semibold hover:opacity-70 transition-opacity" data-id="element-144">
                Cookie Care
              </button>
            </div>

            <div className="flex-shrink-0 flex items-center justify-center" data-id="element-145">
              <img src="https://cdn.magicpatterns.com/uploads/sS6qHYhmzGXJTk6SRnYS13/Crumbssi_Logo-Vertical-Purple.png" alt="Crumbssi Logo" className="h-16 w-auto object-contain" data-id="element-146" />
            </div>

            <div className="hidden md:flex flex-1 justify-start pl-8 space-x-8" data-id="element-147">
              <a href="#menu" className="text-brand-purple font-semibold hover:opacity-70 transition-opacity" data-id="element-148">
                Review Menu
              </a>
              <a href="#faq" className="text-brand-purple font-semibold hover:opacity-70 transition-opacity" data-id="element-149">
                FAQ
              </a>
              <button onClick={() => setShowShippingPolicy(true)} className="text-brand-purple font-semibold hover:opacity-70 transition-opacity" data-id="element-150">
                Shipping Policy
              </button>
            </div>

            {/* Mobile menu links */}
            <div className="flex md:hidden space-x-3 text-sm" data-id="element-151">
              <a href="#menu" className="text-brand-purple font-semibold" data-id="element-152">
                Menu
              </a>
              <button onClick={() => setShowCookieCare(true)} className="text-brand-purple font-semibold" data-id="element-153">
                Cookie Care
              </button>
              <button onClick={() => setShowShippingPolicy(true)} className="text-brand-purple font-semibold" data-id="element-154">
                Shipping
              </button>
              <a href="#faq" className="text-brand-purple font-semibold" data-id="element-155">
                FAQ
              </a>
            </div>
          </div>
        </div>
      </header>

      <AnimatePresence data-id="element-156">
        {showCookieCare && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShowCookieCare(false)} data-id="element-157">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="bg-white rounded-[24px] shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8" onClick={e => e.stopPropagation()} data-id="element-158">
              <div className="flex justify-between items-center mb-6" data-id="element-159">
                <h2 className="text-2xl font-bold text-brand-purple font-serif" data-id="element-160">
                  Cookie Care
                </h2>
                <button onClick={() => setShowCookieCare(false)} className="w-10 h-10 rounded-full bg-brand-pink text-brand-purple flex items-center justify-center hover:bg-brand-purple hover:text-white transition-colors font-bold text-lg" aria-label="Close" data-id="element-161">
                  ✕
                </button>
              </div>
              <div className="text-brand-purple/80 text-sm leading-relaxed space-y-4" data-id="element-162">
                <p data-id="element-163">
                  Thank you for choosing our Crumbssi Cookies! These thick,
                  chewy cookies are made with the finest ingredients and are
                  meant to be enjoyed fresh, but with the proper care, you can
                  extend their enjoyment for days. Here's how to keep them at
                  their best:
                </p>
                <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-164">
                  Storage Recommendations
                </h3>
                <p data-id="element-165">
                  <strong data-id="element-166">Room Temperature Storage</strong> — For optimal
                  freshness, store your cookies in an airtight container at room
                  temperature. They will stay fresh for up to 7 days this way.
                  This prevents them from becoming dry or losing their signature
                  chewiness.
                </p>
                <p data-id="element-167">
                  <strong data-id="element-168">For Extended Freshness – Freezing</strong> — If you
                  need to keep your cookies longer than a few days, freezing is
                  the best option. Wrap each cookie individually in plastic wrap
                  or place them in an airtight freezer bag to protect against
                  freezer burn. When ready to eat, let them thaw at room
                  temperature for about 20-30 minutes, or warm them in the oven
                  at 350°F (175°C) for 8-10 minutes to refresh their texture.
                </p>
                <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-169">
                  Reheating Tips
                </h3>
                <p data-id="element-170">
                  <strong data-id="element-171">Oven:</strong> Preheat your oven to 350°F (175°C) and
                  place the cookie on a baking sheet. Heat for 5-7 minutes for a
                  warm, gooey center with a slightly crispy edge.
                </p>
                <p data-id="element-172">
                  <strong data-id="element-173">Microwave:</strong> Place your cookie on a
                  microwave-safe plate and heat for 10-15 seconds. Be cautious
                  not to overheat, as this can cause the cookie to become too
                  soft or lose its texture.
                </p>
                <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-174">
                  Serving Suggestions
                </h3>
                <p data-id="element-175">
                  Serve your cookies warm with a glass of milk or a scoop of ice
                  cream for the ultimate indulgence, or enjoy them with coffee
                  for a comforting treat.
                </p>
                <p data-id="element-176">
                  If you want a gourmet twist, drizzle with melted chocolate or
                  add a sprinkle of sea salt before serving.
                </p>
                <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-177">
                  Important Notes
                </h3>
                <p data-id="element-178">
                  <strong data-id="element-179">Humidity & Temperature:</strong> Keep cookies away
                  from heat sources, direct sunlight, or humid environments, as
                  these can alter their texture and taste.
                </p>
                <p data-id="element-180">
                  <strong data-id="element-181">Avoid Refrigeration:</strong> We recommend avoiding
                  refrigeration for your cookies as it can cause them to dry
                  out.
                </p>
                <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-182">
                  Allergy Warning
                </h3>
                <p data-id="element-183">
                  Food allergies are a serious matter, and we want to ensure
                  that you are fully informed about the ingredients in our
                  cookies.
                </p>
                <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-184">
                  Common Allergens in Our Products
                </h3>
                <p data-id="element-185">
                  Our cookies may contain one or more of the following
                  ingredients:
                </p>
                <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-186">
                  <li data-id="element-187">Wheat (Gluten)</li>
                  <li data-id="element-188">Dairy (Milk)</li>
                  <li data-id="element-189">Eggs</li>
                  <li data-id="element-190">Nuts (e.g., almonds, walnuts, pecans)</li>
                  <li data-id="element-191">Peanuts</li>
                  <li data-id="element-192">Soy</li>
                  <li data-id="element-193">Corn</li>
                  <li data-id="element-194">Chocolate (may contain traces of dairy or soy)</li>
                </ul>
                <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-195">
                  Cross-Contamination Warning
                </h3>
                <p data-id="element-196">
                  While we take great care in preparing our cookies, all of our
                  products are made in a facility that processes wheat, dairy,
                  eggs, nuts, peanuts, soy, and other allergens. As such, we
                  cannot guarantee that any of our cookies are completely free
                  from trace amounts of allergens due to potential
                  cross-contamination.
                </p>
              </div>
            </motion.div>
          </motion.div>}

        {showShippingPolicy && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={() => setShowShippingPolicy(false)} data-id="element-197">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="bg-white rounded-[24px] shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8" onClick={e => e.stopPropagation()} data-id="element-198">
              <div className="flex justify-between items-center mb-6" data-id="element-199">
                <h2 className="text-2xl font-bold text-brand-purple font-serif" data-id="element-200">
                  Shipping Policy
                </h2>
                <button onClick={() => setShowShippingPolicy(false)} className="w-10 h-10 rounded-full bg-brand-pink text-brand-purple flex items-center justify-center hover:bg-brand-purple hover:text-white transition-colors font-bold text-lg" aria-label="Close" data-id="element-201">
                  ✕
                </button>
              </div>
              <div className="text-brand-purple/80 text-sm leading-relaxed space-y-4" data-id="element-202">
                <p data-id="element-203">
                  At Crumbssi Cookies, we strive to deliver the freshest and
                  most delicious cookies right to your door! Please read our
                  shipping policy carefully to understand the details regarding
                  processing, delivery times, and shipping costs.
                </p>

                <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-204">
                  Order Processing Time
                </h3>
                <p data-id="element-205">
                  All orders are processed on Sundays to be ship out the
                  following Monday.
                </p>
                <p data-id="element-206">
                  Once your order is processed, you will receive a shipping
                  confirmation email with tracking information.
                </p>

                <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-207">
                  Shipping Rates
                </h3>
                <p data-id="element-208">
                  <strong data-id="element-209">Standard Shipping:</strong> We offer flat-rate
                  shipping depending on your location. Rates are calculated at
                  checkout.
                </p>
                <p data-id="element-210">
                  <strong data-id="element-211">Free Shipping:</strong> Enjoy free shipping on orders
                  over $100 (varies by region).
                </p>

                <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-212">
                  Shipping Times
                </h3>
                <p data-id="element-213">
                  <strong data-id="element-214">Standard Shipping:</strong> Typically takes 3-7
                  business days, depending on your location.
                </p>

                <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-215">
                  Packaging
                </h3>
                <p data-id="element-216">
                  Your cookies are carefully packaged to ensure they arrive
                  fresh and intact and making sure your order is safe during
                  transit.
                </p>

                <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-217">
                  Order Tracking
                </h3>
                <p data-id="element-218">
                  Once your order is shipped, we will send you an email with
                  tracking information so you can monitor your delivery status.
                </p>
                <p data-id="element-219">
                  You can track your order directly on the carrier's website
                  using the provided tracking number.
                </p>

                <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-220">
                  Missing or Damaged Orders
                </h3>
                <p data-id="element-221">
                  If your order arrives damaged or is missing, please contact us
                  within 7 days of receiving the package.
                </p>
                <p data-id="element-222">
                  We will work with you to resolve the issue and ensure your
                  satisfaction.
                </p>

                <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-223">
                  Shipping Restrictions
                </h3>
                <p data-id="element-224">
                  We currently do not ship to P.O. Boxes or international
                  addresses.
                </p>
                <p data-id="element-225">
                  Shipping times may be delayed during peak seasons or due to
                  weather conditions.
                </p>

                <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-226">
                  Changes to Shipping Information
                </h3>
                <p data-id="element-227">
                  If you need to update your shipping address after placing an
                  order, please contact us immediately at{' '}
                  <a href="mailto:crumbssicookies@gmail.com" className="underline font-semibold text-brand-purple hover:opacity-70" data-id="element-228">
                    crumbssicookies@gmail.com
                  </a>{' '}
                  so we can make the necessary adjustments before it ships.
                </p>

                <h3 className="text-brand-purple font-bold text-base mt-4" data-id="element-229">
                  Returns and Refunds
                </h3>
                <p data-id="element-230">
                  Due to the nature of our products, we do not accept returns on
                  food items.
                </p>
                <p data-id="element-231">
                  If there is a problem with your order, please refer to our
                  Refund and Returns Policy for more information on how we can
                  assist you.
                </p>

                {/* Contact Form */}
                <div className="mt-8 pt-6 border-t border-brand-purple/10" data-id="element-232">
                  <h3 className="text-brand-purple font-bold text-lg font-serif mb-4" data-id="element-233">
                    Contact Us
                  </h3>
                  {formSubmitted ? <motion.div initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} className="bg-brand-purple/10 rounded-2xl p-6 text-center" data-id="element-234">
                      <span className="text-3xl mb-2 block" data-id="element-235">✉️</span>
                      <p className="text-brand-purple font-bold text-base" data-id="element-236">
                        Message sent!
                      </p>
                      <p className="text-brand-purple/70 text-sm mt-1" data-id="element-237">
                        We'll get back to you soon.
                      </p>
                    </motion.div> : <form onSubmit={handleFormSubmit} className="space-y-4" data-id="element-238">
                      <input type="hidden" name="_subject" value="New Contact from Crumbssi Website" data-id="element-239" />
                      <input type="hidden" name="_captcha" value="false" data-id="element-240" />
                      <div data-id="element-241">
                        <label htmlFor="contact-name" className="block text-brand-purple font-semibold text-sm mb-1" data-id="element-242">
                          Name
                        </label>
                        <input id="contact-name" name="name" type="text" required placeholder="Your name" className="w-full px-4 py-3 rounded-xl border border-brand-purple/20 bg-white/60 text-brand-purple placeholder:text-brand-purple/40 focus:outline-none focus:ring-2 focus:ring-brand-purple/30 text-sm" data-id="element-243" />
                      </div>
                      <div data-id="element-244">
                        <label htmlFor="contact-phone" className="block text-brand-purple font-semibold text-sm mb-1" data-id="element-245">
                          Phone Number
                        </label>
                        <input id="contact-phone" name="phone" type="tel" required placeholder="(555) 123-4567" className="w-full px-4 py-3 rounded-xl border border-brand-purple/20 bg-white/60 text-brand-purple placeholder:text-brand-purple/40 focus:outline-none focus:ring-2 focus:ring-brand-purple/30 text-sm" data-id="element-246" />
                      </div>
                      <div data-id="element-247">
                        <label htmlFor="contact-email" className="block text-brand-purple font-semibold text-sm mb-1" data-id="element-248">
                          Email
                        </label>
                        <input id="contact-email" name="email" type="email" required placeholder="you@example.com" className="w-full px-4 py-3 rounded-xl border border-brand-purple/20 bg-white/60 text-brand-purple placeholder:text-brand-purple/40 focus:outline-none focus:ring-2 focus:ring-brand-purple/30 text-sm" data-id="element-249" />
                      </div>
                      <div data-id="element-250">
                        <label htmlFor="contact-message" className="block text-brand-purple font-semibold text-sm mb-1" data-id="element-251">
                          Description
                        </label>
                        <textarea id="contact-message" name="message" required rows={4} placeholder="How can we help you?" className="w-full px-4 py-3 rounded-xl border border-brand-purple/20 bg-white/60 text-brand-purple placeholder:text-brand-purple/40 focus:outline-none focus:ring-2 focus:ring-brand-purple/30 text-sm resize-none" data-id="element-252" />
                      </div>
                      <button type="submit" className="w-full py-3.5 rounded-full bg-brand-purple text-white font-bold text-sm uppercase tracking-wide hover:bg-brand-purple/90 transition-colors shadow-md hover:scale-[1.02] transition-transform" data-id="element-253">
                        Send
                      </button>
                    </form>}
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}